var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-12" }, [
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submit($event)
            }
          }
        },
        [_c("buttons", { attrs: { top: "" } })],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-12" }, [
      _c("h4", [_vm._v("Deals")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("Please add any deals the provider has been involved in.")
      ]),
      _vm._v(" "),
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "button",
                {
                  staticClass: "btn-default btn-create",
                  staticStyle: { "margin-top": "0px", "margin-left": "0px" },
                  attrs: { type: "button" },
                  on: { click: _vm.createNewDeal }
                },
                [_vm._v("\n          Create new deal\n        ")]
              ),
              _vm._v(" "),
              _vm._l(_vm.deals, function(deal, index) {
                return _c(
                  "div",
                  [
                    _c("hr", { staticStyle: { "margin-top": "20px" } }),
                    _vm._v(" "),
                    _c("inputForm", { key: index, attrs: { index: index } })
                  ],
                  1
                )
              })
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submit($event)
            }
          }
        },
        [_c("buttons")],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-316b83ab", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-316b83ab","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dealPage.vue
// module id = 202
// module chunks = 0